import RouteStation from "@Route/components/Station/RouteStation";
import RouteConnection from "@Route/components/Connection/RouteConnection";
import React from "react";
import IntermodalRouteWithDetailsType from "@Intermodal/types/IntermodalRouteWithDetails.type";
import RouteWithAddedPropsAndPricesType from "@Route/types/RouteWithAddedPropsAndPrices.type";
import SuggestedRouteType from "@Route/types/SuggestedRoute.type";

interface RouteStationsInfoProps {
    route: IntermodalRouteWithDetailsType | RouteWithAddedPropsAndPricesType | SuggestedRouteType,
    activeHub?: string,
}

const RouteStationsInfo = ({route, activeHub}: RouteStationsInfoProps) => {
    const {
        id,
        travelInfo: {
            departureStation: {
                name: departureStationName,
                departureTime: departureTravelTime,
                departureDate,
            },
            destinationStation: {
                name: destinationStationName,
                arrivalTime: arrivalTravelTime,
                arrivalDate,
            },
        },
    } = route

    const showOperatingDate = false

    return (
        <>
            <RouteStation
                routeId={id}
                travelTime={departureTravelTime}
                stationName={departureStationName}
                date={departureDate}
                customClassName="gb--route-element gb--route-station gb--route-station-top"
                showOperatingDate={showOperatingDate}
            />
            <RouteConnection
                route={route}
                showVehicleIcon={false}
                activeHub={activeHub}
                operatingDateShown={showOperatingDate}
            />
            <RouteStation
                routeId={id}
                travelTime={arrivalTravelTime}
                stationName={destinationStationName}
                date={arrivalDate}
                customClassName="gb--route-element gb--route-station gb--route-station-bottom"
                showOperatingDate={showOperatingDate}
            />
        </>
    )
}

export default RouteStationsInfo